<script setup lang="ts">
import Button from '@/components/ui/button/Button.vue'
import { Phone } from 'lucide-vue-next'

interface Props {
  disabled?: boolean
  fullWidth?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  fullWidth: true
})

const emit = defineEmits<{
  click: []
}>()

const handleClick = () => {
  emit('click')
}
</script>

<template>
  <Button
    @click="handleClick"
    :disabled="disabled"
    :class="[fullWidth ? 'w-full' : '', 'gap-3']"
    variant="outline"
  >
    <!-- Phone Icon -->
    <Phone class="w-5 h-5" />
    <span>Sign in with phone number</span>
  </Button>
</template>
